<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h1>{{ SETTING['system'] }}</h1>
                <p class="text-muted">Sign In to your account</p>
                <b-input-group class="mb-3">
                  <div class="input-group-prepend"><span class="input-group-text"><i class="icon-user"></i></span></div>
                  <b-form-input
                    :state="$v.username.$error?false:null"
                    type="text"
                    v-model.trim="username"
                    placeholder="Username"
                    @input.native="wrongCrud=false"
                    @keyup.enter.native="login"
                    >
                  </b-form-input>
                  <div class="invalid-feedback d-block" v-if="$v.username.$error && !$v.username.required">Username is Required</div>
                </b-input-group>
                <b-input-group class="mb-4">
                  <div class="input-group-prepend"><span class="input-group-text"><i class="icon-lock"></i></span></div>
                  <b-form-input
                    :state="$v.password.$error?false:null"
                    type="password"
                    v-model.trim="password"
                    placeholder="Password"
                    @input.native="wrongCrud=false"
                    @keyup.enter.native="login"
                    >
                  </b-form-input>
                  <div class="invalid-feedback d-block" v-if="$v.password.$error && !$v.password.required">Password is Required!</div>
                  <div class="invalid-feedback d-block" v-if="wrongCrud">Username or Password is incorrect!</div>
                </b-input-group>
                <div class="invalid-feedback d-block" v-if="accDisable">
                  You Account has been disabled.
                  <br>
                  <br>
                </div>
                <b-row>
                  <b-col cols="6">
                    <b-button variant="primary" class="px-4" @click="login">Login</b-button>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
    <b-modal v-model="showApplicationMsgModal" size="md" centered :header-bg-variant="applicationBg" hide-footer :title="applicationTitleMsg" @hide="showInReviewMsgModal = false">
      <div class="d-block">
        <b-row>
          <b-col sm="12" v-html="applicationMsg">
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>

const {required} = require('vuelidate/lib/validators')

export default {
  name: 'Login',
  data: () => {
    return {
      showApplicationMsgModal: false,
      applicationMsg: '',
      applicationBg: '',
      applicationTitleMsg: '',
      reviewMsg: `<p>Thank you for your application!</p>
      <p>Your application is being reviewed. Please contact us if you do not hear from us after 48 hours.<br><br>Have a great day!</p>`,
      rejectedMsg: `<p>Your application has been rejected !</p>
      <p>Have a great day !</p>`,
      username: '',
      password: '',
      wrongCrud: false,
      accDisable: false
    }
  },
  validations: {
    username: { required },
    password: { required }
  },
  watch: {
    username: function (val) {
      if (this.accDisable) {
        this.accDisable = false
      }
    }
  },
  methods: {
    async login () {
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else {
        try {
          const response = await this.$http.post(this.API_ENDPOINT + '/api/v1/agent/auth/login', { username: this.username, password: this.password }, {headers: { 'Content-Type': 'application/json' }})
          window.sessionStorage.setItem('client', JSON.stringify(response.data.user))
          window.location.href = '/'
        } catch (err) {
          if (err.response.data.code === 'code.account.disabled') {
            this.accDisable = true
            this.wrongCrud = false
          } else if (err.response.data.code === 'code.account.review') {
            this.showApplicationMsgModal = true
            this.applicationMsg = this.reviewMsg
            this.applicationTitleMsg = 'Account Under Review'
            this.applicationBg = 'success'
          } else if (err.response.data.code === 'code.account.rejected') {
            this.showApplicationMsgModal = true
            this.applicationMsg = this.rejectedMsg
            this.applicationTitleMsg = 'Account Application Rejected'
            this.applicationBg = 'danger'
          } else {
            this.wrongCrud = true
            this.accDisable = false
          }
          console.log('this is an error ', err.response)
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/pages/Login.vue